<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title fz-23"><i
      class="fa fa-spell-check"></i> {{ "TITLE.ADD-DIGITAL-SIGNATURE-DESCRIPTION" | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="authorityForm">
      <div class="row">
        <div class="col">
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col">
              <div class="custom-control custom-checkbox my-1 mr-sm-2">
                <input type="checkbox"
                       class="custom-control-input"
                       id="addRemoveAllCheckbox1"
                       [checked]="wasAllSelected1()"
                       (click)="addOrRemoveAll1($event)">
                <label class="custom-control-label"
                       for="addRemoveAllCheckbox1"><b>{{ "LABEL.ALL" | translate }}</b></label>
              </div>
              <div class="custom-control custom-checkbox my-1 mr-sm-2"
                   *ngFor="let signatureDescription of signatureDescriptions; let index=index">
                <input type="checkbox"
                       class="custom-control-input"
                       id="addPermisoCheckbox{{index}}"
                       name="workflowCheckbox"
                       [value]="signatureDescription.id"
                       [checked]="wasSelected(signatureDescription)"
                       (change)="addRemove($event, signatureDescription)">
                <label class="custom-control-label"
                       for="addPermisoCheckbox{{index}}">
                  {{signatureDescription.nameView }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success" [disabled]="!areThereSelectedWorkflows"
            (click)="save()">
      <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger" (click)="cancel()">
      <i class="fa fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>


